export default __webpack_public_path__ + "static/media/project_thumbnail_lhca.2ad69cc7.png";